export const sameInputTransformer = <T>(data: T): T => data
